export const SERVICES = {
  pulsa: {
    title: 'Pulsa',
    apiType: 'PULSA',
    label: 'Nomor HP',
    phone: true
  },
  data: {
    title: 'Paket Data',
    apiType: 'DATA',
    label: 'Nomor HP',
    phone: true
  },
  ewallet: {
    title: 'E-Wallet',
    apiType: 'EWALLET',
    label: 'Nomor HP E-Wallet',
    phone: true
  },
  pln_token: {
    title: 'Token PLN',
    apiType: 'PLN',
    label: 'Nomor Meter / ID Pelanggan'
  },
  pln_bill: {
    title: 'Tagihan PLN',
    apiType: 'PLN',
    label: 'ID Pelanggan'
  },
  pdam: {
    title: 'PDAM',
    apiType: 'PDAM',
    label: 'ID Pelanggan'
  },
  bpjs: {
    title: 'BPJS Kesehatan',
    apiType: 'BPJS',
    label: 'Nomor Kartu BPJS'
  },
  game: {
    title: 'Voucher Game',
    apiType: 'OTHER',
    label: 'User ID Game'
  },
  transfer: {
    title: 'Transfer Bank',
    apiType: 'OTHER',
    label: 'Nomor Rekening'
  },
  qris: {
    title: 'QRIS',
    apiType: 'OTHER',
    label: 'Referensi Tujuan'
  },
  other: {
    title: 'Produk Lainnya',
    apiType: 'OTHER',
    label: 'Nomor / ID Tujuan'
  }
};

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function hasProductUuid(product) {
  return UUID_PATTERN.test(String(product?.id || ''));
}

function positivePrice(value) {
  const price = Number(value);
  return Number.isFinite(price) && price > 0 ? price : null;
}

export function productPriceForRole(product) {
  return positivePrice(product?.sellPrice ?? product?.sell_price);
}

export function productBrand(product) {
  return product?.brand || product?.metadata?.brand || product?.metadata?.operator || '';
}

export function productSearchText(product) {
  return [
    product?.name,
    product?.category,
    productBrand(product),
    product?.metadata?.product_name,
  ].filter(Boolean).join(' ').toLowerCase();
}

export function matchesProductSearch(product, query) {
  const normalize = value => String(value || '').toLowerCase().replace(/by[.\s-]*u/g, 'byu').trim();
  return normalize(productSearchText(product)).includes(normalize(query));
}

export function compareCatalogProducts(a, b) {
  const brandCompare = productBrand(a).localeCompare(productBrand(b), 'id', { sensitivity: 'base' });
  if (brandCompare !== 0) return brandCompare;
  return String(a?.name || '').localeCompare(String(b?.name || ''), 'id', { numeric: true, sensitivity: 'base' });
}

export function normalizePhone(value) {
  const compact = String(value || '').replace(/[\s()-]/g, '');
  return compact.startsWith('+62') ? '0' + compact.slice(3) : compact.startsWith('62') ? '0' + compact.slice(2) : compact.startsWith('8') ? '0' + compact : compact;
}
export function detectOperator(value) {
  const prefix = normalizePhone(value).slice(0, 4);
  const operators = {
    Telkomsel: ['0811', '0812', '0813', '0821', '0822', '0823', '0851', '0852', '0853'],
    Indosat: ['0814', '0815', '0816', '0855', '0856', '0857', '0858'],
    XL: ['0817', '0818', '0819', '0859', '0877', '0878'],
    AXIS: ['0831', '0832', '0833', '0838'],
    Tri: ['0895', '0896', '0897', '0898', '0899'],
    Smartfren: ['0881', '0882', '0883', '0884', '0885', '0886', '0887', '0888', '0889']
  };
  return Object.keys(operators).find(key => operators[key].includes(prefix)) || null;
}
export function productOperator(product) {
  const text = [product.category, product.name, product.code, product.brand, product.metadata?.brand, product.metadata?.operator].filter(Boolean).join(' ').toLowerCase();
  const rules = {
    Telkomsel: /telkomsel|tsel|simpati|kartu\s*as|by[ .]?u/,
    Indosat: /indosat|im3|mentari|isat/,
    AXIS: /axis/,
    XL: /\bxl\b|xlri/,
    Tri: /\btri\b|three|\b3\b/,
    Smartfren: /smartfren|smart\s*fren/
  };
  return Object.keys(rules).find(key => rules[key].test(text)) || null;
}
function productType(product) {
  const type = String(product.type || product.productType || product.product_type || '').trim().toUpperCase();
  if (type === 'PAKET_DATA' || type === 'INTERNET' || type === 'DATA_PACKAGE') return 'DATA';
  if (type === 'PULSA_REGULER' || type === 'PHONE_CREDIT') return 'PULSA';
  return type;
}
export function matchesService(product, type) {
  const service = SERVICES[type];
  if (!service || product.isActive === false || product.buyerProductStatus === false || product.sellerProductStatus === false) return false;
  const text = `${product.category || ''} ${product.name || ''} ${product.code || ''} ${product.product_name || ''}`.toLowerCase();
  const apiType = productType(product);
  const backendType = String(product.serviceType || '').toUpperCase();
  if (apiType && apiType !== service.apiType && backendType !== service.apiType) return false;
  if (!apiType && backendType !== service.apiType && type !== 'other') return false;
  if (type === 'pln_bill') return /tagihan|bill|postpaid|pascabayar/.test(text);
  if (type === 'pln_token') return !/tagihan|bill|postpaid|pascabayar/.test(text);
  if (type === 'game') return /game|voucher|mobile legends|free fire|pubg/.test(text);
  if (type === 'transfer') return /transfer|bank/.test(text);
  if (type === 'qris') return /qris/.test(text);
  return true;
}
export function validTarget(value, service) {
  return service?.phone ? /^08\d{8,11}$/.test(normalizePhone(value)) : /^[A-Za-z0-9+\-]{3,50}$/.test(value.trim());
}
export function balanceSufficient(balance, required) {
  const available = Number(balance ?? 0);
  const needed = Number(required ?? 0);
  if (!Number.isFinite(available) || !Number.isFinite(needed)) return false;
  return available >= needed;
}
export async function fetchCatalog(client, type, signal) {
  const pageSize = 200;
  const items = [];
  const seen = new Set();
  let skip = 0;
  while (true) {
    const { data } = await client.get('/products', {
      signal,
      params: { skip, take: pageSize },
    });
    if (!Array.isArray(data)) {
      throw new Error('Format katalog internal tidak valid. Silakan coba lagi.');
    }
    if (data.length === 0) break;
    let freshCount = 0;
    data.forEach((product) => {
      if (!product.id || typeof product.name !== 'string') {
        throw new Error('Data katalog internal tidak valid. Silakan coba lagi.');
      }
      if (seen.has(product.id)) return;
      seen.add(product.id);
      items.push(product);
      freshCount += 1;
    });
    if (freshCount === 0) {
      throw new Error('Halaman katalog internal tidak berubah. Silakan coba lagi.');
    }
    skip += data.length;
    if (data.length < pageSize) break;
  }
  return items
    .filter((product) => !type || productType(product) === String(type).trim().toUpperCase())
    .map((product) => ({
      ...product,
      name: product.name,
    }))
    .sort(compareCatalogProducts);
}
